"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityActivityMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const roles_entity_1 = require("./roles.entity");
const look_up_entity_1 = require("./look-up.entity");
const user_1 = require("./user");
let OpportunityActivityMap = class OpportunityActivityMap {
    constructor(id, opportunityId, refStageId, refActivityId, activityName, stageName, leadRoleId, originalDueDate, leadDays, approval, mandatory, activityMeta, opportunityTable, statusLid, ownerId, dueDate, activityKey, createdAt, updatedAt) {
        this.id = id;
        this.opportunityId = opportunityId;
        this.refStageId = refStageId;
        this.refActivityId = refActivityId;
        this.activityName = activityName;
        this.stageName = stageName;
        this.leadRoleId = leadRoleId;
        this.originalDueDate = originalDueDate;
        this.leadDays = leadDays;
        this.approval = approval;
        this.mandatory = mandatory;
        this.activityMeta = activityMeta;
        this.opportunityTable = opportunityTable;
        this.statusLid = statusLid;
        this.ownerId = ownerId;
        this.dueDate = dueDate;
        this.activityKey = activityKey;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
};
exports.OpportunityActivityMap = OpportunityActivityMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opty_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityMap.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "ref_stage_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityMap.prototype, "refStageId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "ref_activity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityMap.prototype, "refActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_name", type: "varchar", nullable: false }),
    tslib_1.__metadata("design:type", String)
], OpportunityActivityMap.prototype, "activityName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "stage_name", type: "varchar", nullable: false }),
    tslib_1.__metadata("design:type", String)
], OpportunityActivityMap.prototype, "stageName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "lead_role_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityMap.prototype, "leadRoleId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "original_due_date", type: "date", nullable: false }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], OpportunityActivityMap.prototype, "originalDueDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "lead_days", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityMap.prototype, "leadDays", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "approval", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], OpportunityActivityMap.prototype, "approval", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "mandatory", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], OpportunityActivityMap.prototype, "mandatory", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_meta", type: "jsonb", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Record !== "undefined" && Record) === "function" ? _g : Object)
], OpportunityActivityMap.prototype, "activityMeta", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "due_date", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], OpportunityActivityMap.prototype, "dueDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "owner_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityMap.prototype, "ownerId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "ref_role_key", type: "varchar", nullable: false }),
    tslib_1.__metadata("design:type", String)
], OpportunityActivityMap.prototype, "roleKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_j = typeof Date !== "undefined" && Date) === "function" ? _j : Object)
], OpportunityActivityMap.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_k = typeof Date !== "undefined" && Date) === "function" ? _k : Object)
], OpportunityActivityMap.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityMap.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityMap.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_table", type: "varchar", nullable: true }),
    tslib_1.__metadata("design:type", String)
], OpportunityActivityMap.prototype, "opportunityTable", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "activity_key",
        type: "varchar",
        length: 100,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", String)
], OpportunityActivityMap.prototype, "activityKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "status_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityMap.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opty_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityActivityMap.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => roles_entity_1.Role, (role) => role.id, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "lead_role_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityActivityMap.prototype, "leadRole", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "status_lid" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityActivityMap.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => user_1.User),
    (0, typeorm_1.JoinColumn)({ name: "created_by", referencedColumnName: "userId" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityActivityMap.prototype, "created", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_1.User, (user) => user.userId, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "owner_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityActivityMap.prototype, "owner", void 0);
exports.OpportunityActivityMap = OpportunityActivityMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_activity_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, String, String, Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, Number, String, String, typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object, String, Number, Number, typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object, String, typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object, typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object])
], OpportunityActivityMap);
